export default __webpack_public_path__ + "static/char-s-29-zh-Hant-7e2081ba2d7021ae70b51ef5c466f8b7.png";